import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './Loader.css';

class Loader extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    isHidden: PropTypes.bool,
    className: PropTypes.string.isRequired,
    defaultClassName: PropTypes.string,
    loaderElement: PropTypes.node,
  };
  static defaultProps = {
    isLoading: false,
    isHidden: false,
    children: '',
    className: '',
    defaultClassName: '',
    loaderElement: null,
  };

  render() {
    const {
      isLoading,
      children,
      isHidden,
      className,
      loaderElement,
      defaultClassName,
    } = this.props;

    if (isHidden) {
      return null;
    }

    return isLoading ? (
      <div className={cx(s.root, className)}>
        {loaderElement || <i className="fa fa-2x fa-spinner fa-spin" />}
      </div>
    ) : (
      <div className={defaultClassName}>{children}</div>
    );
  }
}

export default withStyles(s)(Loader);



// WEBPACK FOOTER //
// ./src/shared/components/Loader/Loader.js